<template>
  <shell>
    <div class="lg:w-full container m-auto">
      <div class="w-full lg:w-1/2 m-auto relative px-2">
        <h2 class="text-2xl pb-4">Create API Spell</h2>

        <div v-if="error" class="px-4 py-2 mb-4 bg-red-lightest">
          <t-text kind="DANGER">{{error}}</t-text>
        </div>

        <div class="pb-10">
          <div class="bg-black py-4 px-2 rounded">
            <div class="pb-4 text-base font-bold text-white">Notes API</div>
            <div class="mb-4 rounded text-sm text-white bg-black">
              <div class="pb-2">
                Using folder <span class="font-bold font-mono path text-black bg-light-yellow">
                {{api.folder}}
                </span>
              </div>
              <div class="text-xs font-bold">
                <span v-if="api.is_readonly">
                  This API can only read notes in {{api.folder}}
                </span>
                <span v-else>
                  This API can
                  <strong>read, create, update and delete</strong> notes in {{api.folder}}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="block">
          <edit-api v-model="api" />

          <div class="text-xs pb-6">Once you create the API, the URL and API key will be available on the Spells page.</div>

          <div class="flex justify-end items-center">
            <router-link class="ml-4 text-black no-underline" to="/spells">Cancel</router-link>
            <t-button class="ml-4" @click="handler">Make API</t-button>
          </div>
        </div>
      </div>
    </div>
  </shell>
</template>

<script>
 import {mapState} from 'vuex';
 import api from '@/api';
 import Shell from '@/components/Shell';
 import EditApi from '@/components/EditApi';

 export default {
   components: {Shell, EditApi},

   data () {
     return {
       error: '',
       api: {is_readonly: true, folder: '/'}
     }
   },

   computed: {
     ...mapState({

     }),
   },

   methods: {
     async handler () {

       const {err} = await api.createApi({
         folder: this.api.folder,
         is_readonly: this.api.is_readonly
       });

       if (err) {
         this.error = err.response.data;
         return;
       }

       this.$router.push({name: 'spells'});
     }
   },

   watch: {

   }
 }
</script>
